import { render, staticRenderFns } from "./LugarInteresModalEdicion.vue?vue&type=template&id=49240181&scoped=true&"
import script from "./LugarInteresModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./LugarInteresModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./LugarInteresModalEdicion.vue?vue&type=style&index=0&id=49240181&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49240181",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('49240181', component.options)
    } else {
      api.reload('49240181', component.options)
    }
    module.hot.accept("./LugarInteresModalEdicion.vue?vue&type=template&id=49240181&scoped=true&", function () {
      api.rerender('49240181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/LugarInteresModalEdicion.vue"
export default component.exports